"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AppState;

(function (AppState) {
  AppState["NotSetup"] = "not-setup";
})(AppState = exports.AppState || (exports.AppState = {}));